<template>
  <div class="video-wrapper">
    <video
      ref="video"
      :src="source.src"
      :type="source.type"
      :autoplay="autoplay"
      playsinline
      preload="auto"
      @timeupdate="onTimeUpdate"
      @ended="onEnded"
    ></video>
  </div>
</template>

<script>
export default {
  name: 'VideoControl',
  props: {
    source: {
      type: Object,
      required: true,
    },
    autoplay: {
      type: Boolean,
      required: false,
      default: true
    },
    alarm: {
      type: Object,
      required: false,
      default: null
    }
  },
  data() {
    return {
      alarmState: -1,
      chapter: { start: 0, end: -1 },
      complete: false,
    }
  },
  methods: {
    play() {
      this.playFrom(0);
    },
    pause() {
      if (!this.$refs['video'].paused) {
        this.$refs['video'].pause();
      }
    },
    resume() {
      if (this.$refs['video'].paused && !this.complete) {
        this.$refs['video'].play();
      }
    },
    getCurrentTime() {
      return this.$refs['video'].currentTime;
    },
    playChapter(chapter) {
      this.chapter = this.normalizeChapter(chapter);
      this.complete = false;
      this.$refs['video'].currentTime = this.chapter.start;
      this.$refs['video'].play();
    },
    playFrom(start) {
      this.playChapter({ start, end: -1 });
    },
    playFromTo(start, end) {
      this.playChapter({ start, end });
    },
    normalizeChapter(chapter) {
      if (chapter.start < 0) {
        chapter.start = this.$refs['video'].currentTime;
      }
      return chapter;
    },
    onTimeUpdate(event) {
      if (!this.complete && event.target.currentTime >= this.chapter.end) {
        this.complete = true;
        this.pause();
        this.onEnded();
      }
      if (this.alarm !== null) {
        this.checkAlarmState(event.target.currentTime);
      }
    },
    checkAlarmState(currentTime) {
      if (!this.alarm) return;
      
      if (currentTime >= this.alarm.chapter.end && this.alarmState === 0) {
        this.$emit('onAlarm', 'end');
        this.alarmState = -1;
      } else if (currentTime >= this.alarm.chapter.start && this.alarmState === -1) {
        this.$emit('onAlarm', 'start');
        this.alarmState = 0;
      }
    },
    onEnded() {
      this.$emit('onEnded');
    },
  },
}
</script>
